export const TabCountBadge = ({
  count,
  active,
  onPrimary
}: {
  count: number;
  active: boolean;
  /** The badge sits inside an already `bg-primary`-filled surface (the
   * sub-lg pills' active state) rather than beside underlined text, so the
   * active treatment below would be invisible against its own background.
   * Renders a translucent on-primary tint instead. */
  onPrimary?: boolean;
}) => (
  <span
    className={`ml-1.5 inline-flex min-w-5 items-center justify-center rounded-full px-1.5 py-0.5 text-xs ${
      active
        ? onPrimary
          ? 'bg-primary-foreground/20 text-primary-foreground'
          : 'bg-primary text-primary-foreground'
        : 'bg-muted text-muted-foreground'
    }`}
  >
    {count}
  </span>
);
